import type { Game, GameLabel } from '../../../stores/game/types';
import { useStores } from '../../../stores/useStores';

export const useGameLabels = (game: Game, gameLabelFF: boolean) => {
  const { tournamentStore, dailyMissionsStore, coinTypeStore, prizeDropStore } = useStores();

  if (!gameLabelFF) {
    return {
      tagGameLabels: [],
      iconGameLabels: [],
    };
  }

  const { coinType: currentCoinType } = coinTypeStore;

  const { gameLabels = [] } = game;

  const { currentTournament, tournamentGameLabel } = tournamentStore;
  const { gcUserDailyMissions, scUserDailyMissions, dailyMissionGameLabel } = dailyMissionsStore;

  const tagGameLabels: GameLabel[] = gameLabels.filter((label) => !label.iconSrc);
  const gameLabelsWithIcons = gameLabels.filter((label) => !!label.iconSrc);
  const iconGameLabels: GameLabel[] = gameLabelsWithIcons;

  const currentDailyMissions = currentCoinType === 'GC' ? gcUserDailyMissions : scUserDailyMissions;
  const isDailyMissionOnGame = currentDailyMissions.some((mission) => mission.gameId === game.masterCasinoGameId);
  const { prizeDropEvent } = prizeDropStore;

  const isPrizeDropOnGame = prizeDropEvent?.eventScopes.participatingGames.some(
    (gameId) => gameId === game.masterCasinoGameId,
  );

  const isPrizeDropOnProvider = prizeDropEvent?.eventScopes.participatingProviders.some(
    (gameId) => gameId === game.masterCasinoProviderId,
  );

  if (currentTournament && tournamentGameLabel) {
    const { tournamentGroup } = currentTournament;

    const isTournamentOnGame =
      (tournamentGroup.gameId && tournamentGroup.gameId === game.identifier) ||
      (tournamentGroup.categoryId &&
        (tournamentGroup.categoryId === game.masterGameSubCategoryId ||
          game.gameCategoryConnections?.some(
            (category) => category.masterGameSubCategoryId === tournamentGroup.categoryId, // For search
          )));

    if (isTournamentOnGame) {
      iconGameLabels.unshift(tournamentGameLabel);
    }
  }

  if (isDailyMissionOnGame && dailyMissionGameLabel) {
    iconGameLabels.unshift(dailyMissionGameLabel);
  }

  if (prizeDropEvent && (isPrizeDropOnGame || isPrizeDropOnProvider) && prizeDropEvent.gameLabel) {
    iconGameLabels.unshift(prizeDropEvent.gameLabel);
  }

  return {
    tagGameLabels,
    iconGameLabels,
  };
};
